"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _attach = _interopRequireDefault(require("../attach"));

var _button = _interopRequireDefault(require("../button"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ButtonField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(ButtonField, _React$PureComponent);

  var _super = _createSuper(ButtonField);

  function ButtonField() {
    var _this;

    (0, _classCallCheck2.default)(this, ButtonField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClick", function () {
      var type = _this.props.type; // Is the button not a submit button? Let the form handle submit buttons so that the form
      // performs the validation

      if (type !== 'submit') {
        _this.props.component.emitClick();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(ButtonField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          label = _this$props.label,
          type = _this$props.type,
          disabled = _this$props.disabled,
          icon = _this$props.icon,
          fullWidth = _this$props.fullWidth,
          variant = _this$props.variant,
          tooltip = _this$props.tooltip;
      return /*#__PURE__*/_react.default.createElement(_button.default, {
        type: type,
        label: label,
        disabled: disabled,
        onClick: this.handleClick,
        icon: icon,
        fullWidth: fullWidth,
        variant: variant,
        tooltip: tooltip
      });
    }
  }]);
  return ButtonField;
}(_react.default.PureComponent);

var _default = (0, _attach.default)(['label', 'type', 'disabled', 'icon', 'fullWidth', 'variant', 'tooltip'])(ButtonField);

exports.default = _default;